module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_feature_1-e31ad8cfc28ef9060ea6bf41dc0820b5.svg";